import React, { useCallback, useContext } from 'react';
import { Space, message } from 'antd';
import * as Icons from '@ant-design/icons';
import { HeadPortal } from '@modules/layout/components/head-portal';
import { StyledHeaderButton } from '@modules/layout/styled';
import { StyledActionBar } from '@shared/styled/action-bar';
import { useBackgroundNavigate } from '@shared/hooks/use-background-navigate';
import { useAuth } from '@modules/me';
import { CashRegistersTableContext } from '../context';
import { CashRegistersService } from '../services';

export const CashRegistersActionBar = () => {
  const { state, handleFetch, handleReset, handleSelectAll, handleResetSelection } = useContext(CashRegistersTableContext);
  const { can } = useAuth();
  const navigate = useBackgroundNavigate();
  const selectionCount = Object.keys(state.selectedRowIds || {}).length;

  const openCreate = useCallback(() => {
    navigate('/cash-flow/cash-registers/create', { withBackground: true });
  }, [navigate]);

  const exportAsExcel = useCallback(async () => {
    message.loading({ key: 'cashregisters-export', content: 'Sənəd hazırlanır...', duration: 0 });
    const query: Record<string, any> = {};
    state.filters.forEach((f: any) => {
      query[f.id] = f.value;
    });
    const result = await CashRegistersService.getExcel(query);
    if (result.status === 200) {
      message.success({ key: 'cashregisters-export', content: 'Sənəd yüklənir.' });
      const a = document.createElement('a');
      a.href = URL.createObjectURL(result.data as Blob);
      a.download = 'cash-registers_export.xls';
      a.click();
    } else {
      message.error({ key: 'cashregisters-export', content: result.data as string });
    }
  }, [state.filters]);

  return (
    <HeadPortal>
      <StyledActionBar $flex={true}>
        <Space size={0}>
          <StyledHeaderButton type="text" disabled={!can('cashboxes.cud')} onClick={openCreate} icon={<Icons.PlusCircleOutlined />}>
            Yeni
          </StyledHeaderButton>
          {!selectionCount ? (
            <StyledHeaderButton type="text" onClick={handleSelectAll} icon={<Icons.CheckCircleOutlined />}>
              Hamısını seç
            </StyledHeaderButton>
          ) : (
            <StyledHeaderButton type="text" onClick={handleResetSelection} icon={<Icons.CloseCircleOutlined />}>
              {selectionCount} sətir seçilib
            </StyledHeaderButton>
          )}
          <StyledHeaderButton type="text" onClick={handleFetch} icon={<Icons.ReloadOutlined />}>
            Yenilə
          </StyledHeaderButton>
          <StyledHeaderButton type="text" onClick={handleReset} icon={<Icons.ClearOutlined />}>
            Sıfırla
          </StyledHeaderButton>
        </Space>
        <Space size={0}>
          {!selectionCount && (
            <StyledHeaderButton type="text" onClick={exportAsExcel} icon={<Icons.FileExcelOutlined />}>
              Export
            </StyledHeaderButton>
          )}
        </Space>
      </StyledActionBar>
    </HeadPortal>
  );
};
